<template>
    <div class="score" @mouseleave="value ? score = value : score = 0">
        <div v-for="i in starNumber" :key="i+'score'" @mouseover="setData($event,i)" @click="setData($event,i)" class="score_item" :style="{width:width + 'px',height: height+'px'}" :class="{active: i<= score}"></div>
    </div>
</template>

<script>
   /**
     * ComponentName: 评分组件
     * Created Date:2022/5/7
     * Author: Nancy
     * 组件说明：
     *  width/height 星星的宽高，默认32px
     *  disabled 是否禁用，也就是只能看不可操作，默认可以操作
     * eg:
     *     <cl-score width="16" height="16" v-model="item.score" :disabled="true"></cl-score>
     */
    export default {
        name: 'cl-score',
        data() {
            return {
                score: this.value || 0
            };
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        props: {
            value: {
                type: [String, Number],
                default: 0
            },
            width: {
                type: [String, Number],
                default: 32
            },
            height: {
                type: [String, Number],
                default: 32
            },
            disabled: {
                type: Boolean,
                default: false
            },
            starNumber:{
                type: [Number, String],
                default: 5
            }
        },

        watch: {
            value(val) {
                this.score = val;
            }
        },

        methods: {
            setData(e, i) {
                if (this.disabled) return;
                this.score = i;
                if (e.type === "click") {
                    this.$emit('change', i);
                } 
            }
        }
    }
</script>
<style lang='scss' scoped>
    .score {
        display: flex;
        cursor: pointer;

        .score_item {
            background: url('~@/assets/images/schedule/comment_score_default.png') no-repeat;
            background-size: 100% 100%;

            &.active {
                background: url('~@/assets/images/schedule/comment_score_active.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
</style>
